module.exports = __webpack_public_path__ + "img/0Q3A5468_L_Wood_MockedUp.7e685b85.jpg";